const ANON_EMAIL_DOMAIN = 'hairio.app';

/**
 * Truegate deferred-email flow.
 *
 * The truegate billing backend (recurrentbusiness) keys its customer by email
 * and rejects order creation without one ("Customer not found", 422), so unlike
 * Stripe it cannot charge a user with `email = null`. Instead the customer is
 * created with a synthetic address derived from the anonymous user's uid, and
 * the real email is collected afterwards on the `email-after-payment` page and
 * saved through `/user/update-by-token/{userId}`.
 *
 * Derived from the uid rather than random so the billing customer and the Voery
 * user are linked without a lookup table: given either one, the other follows.
 *
 * NOTE: deliberately `anon-<uid>@`, not `anon+<uid>@`. Plus-addressing is
 * normalized away by many backends, which would collapse every anonymous user
 * into a single `anon@hairio.app` customer — exactly what this avoids.
 */
export const buildAnonEmail = (uid: string): string =>
  `anon-${uid}@${ANON_EMAIL_DOMAIN}`;
